import React, { useEffect, useState } from 'react';
import { Button } from './ui/Button';
export function StickyBar() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const heroHeight = 600; // Approx height of hero
      if (window.scrollY > heroHeight) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  if (!isVisible) return null;
  return <div className="fixed bottom-0 left-0 w-full bg-white/90 backdrop-blur-md border-t border-stone-200 p-4 z-50 shadow-lg transform transition-transform duration-300 animate-slide-up" data-id="element-213">
      <div className="max-w-6xl mx-auto flex items-center justify-between" data-id="element-214">
        <div className="hidden md:block" data-id="element-215">
          <p className="font-serif text-stone-900 font-bold" data-id="element-216">
            Reset Hormonal 14 Días
          </p>
          <p className="text-xs text-stone-500" data-id="element-217">Recupera tu calma y control</p>
        </div>
        <div className="flex items-center gap-4 w-full md:w-auto" data-id="element-218">
          <span className="font-bold text-stone-900 text-lg hidden sm:block" data-id="element-219">
            $6.39 USD
          </span>
          <Button onClick={scrollToPricing} className="w-full md:w-auto py-3 text-sm px-6" data-id="element-220">
            Obtener Acceso
          </Button>
        </div>
      </div>
    </div>;
}